import React, { useCallback, useMemo, useState } from 'react'

type SystemChartsContextType = {
  resetChartSelectionTrigger: boolean
  resetChartSelection: () => void
}

const SystemChartsContext = React.createContext<SystemChartsContextType>({
  resetChartSelectionTrigger: false,
  resetChartSelection: () => undefined,
})

/**
 * * This is a global context provider for system charts
 */

export const SystemChartsProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [resetChartSelectionTrigger, setResetChartSelectionTrigger] = useState(false)

  const resetChartSelection = useCallback((): void => {
    setResetChartSelectionTrigger(prev => !prev)
  }, [])

  const value = useMemo(() => ({ resetChartSelectionTrigger, resetChartSelection }), [resetChartSelectionTrigger, resetChartSelection])

  return <SystemChartsContext.Provider value={value}>{children}</SystemChartsContext.Provider>
}

export const useSystemChartsContext = (): SystemChartsContextType => React.useContext(SystemChartsContext)
